import React from 'react';

import BusinessIcon from '@material-ui/icons/Business';
import BuildOutlinedIcon from '@material-ui/icons/BuildOutlined';

import i18n from '../../i18n';

const menuItems = [
  {
    name: i18n.t`Department`,
    icon: <BusinessIcon />,
    subItems: [
      {
        name: i18n.t`Edit`,
        path: '/admin/department/edit',
        icon: <BuildOutlinedIcon fontSize="small" />,
      },
    ],
    access: ['superadmin', 'manager'],
  },
];

export default menuItems;
